module.exports = __webpack_public_path__ + "static/media/hensler.f093a988.jpg";